import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { Grid } from "@mui/material";
import { propCustomEnumField, propFileField } from "../../common/entityStoreForm";
import { propRequired, propValueValidator } from "../../common/entityStoreValidators";
import { useRxJsSub, withSameProp } from "../../common/utils";
import { createListStore } from "../../common/listStore";
import dayjs from "dayjs";
import { findLast } from "lodash";

export const OrderCycleSkipImportPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: {},
        id: null,
        propValidators: [
            propRequired("file"),
            propRequired("cycleId"),
            propValueValidator("isFileImported", p => p && "File is already imported."),
        ]
    }));
    const [isRunning, setIsRunning] = useState(false);
    const [useCyclesStore] = useState(() => createListStore<CycleDto>({ path: "runs/orderCycleSkipImport/cycles" }));
    useRxJsSub(() => useCyclesStore.getState().items$.subscribe({
        next(value) {
            if (useParamsStore.getState().clientData.cycleId == null && value.items.length > 0) {
                const today = dayjs.tz(undefined).startOf("day");
                useParamsStore.getState().setClientDataProp("cycleId", findLast(value.items,
                    p => dayjs.tz(p.startDate) <= today)?.cycleId ?? value.items.at(0)?.cycleId);
            }
        }
    }));
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
            <Grid item xs={12}>{propCustomEnumField(useParamsStore)("cycleId", "Cycle", useCyclesStore,
                { getId: p => p.cycleId, getName: p => p.name })}</Grid>
        </>;
    }
    return <>
        <Run name="Order cycle skip import" fake={props.fake} hub="orderCycleSkipImport" onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
            useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />
    </>;
});

interface RunParams {
    file?: File;
    isFileImported?: boolean;
    cycleId?: number;
}

interface CycleDto {
    cycleId: number;
    startDate: string;
    name: string;
}